/* eslint-disable max-len */
/* eslint-disable prefer-template */
import React, { useEffect, useState } from 'react';
import './style.css';
import './reg.css';
import WithRegistration from './layouts/withRegistration';
import WithOutRegistration from './layouts/withOutRegistraion';
import { validateAlphaNumericSpecial, validateCharacters, validateEmail, validateIntegers } from '../../libs/validation';
import { createRegister, getWebinarDetals } from '../../libs/apis/webinarApi';
import Loading from '../Loader/Loading';
import WebinarTimer from './timerComponents/webinarTimer';
import { useHistory } from 'react-router-dom';
import Description from './welComePage/description';
import { createBroadcastUser } from '../MeetingDrawer/BroadcastChat/BroadcastAction';
import LinkExpirePage from './invalidLinkPage';

export default function RegistrationPage()
{
	const [ registrationType, setRegistrationType ] = useState(false);
	const [ registrationStatus, setRegistrationStatus ] = useState(false);

	const [ loading, setLoading ] = useState(true);
	const [ regisErr, setRegisErr ] = useState('');

	const urlParser = new URL(window.location);

	const parameters = urlParser.searchParams;
	const meetingId = parameters.get('id');
	const sessionId = parameters.get('sessionId');
	const withRegistration = parameters.get('withRegistration');

	const [ userDetails, setUserDetails ] = useState({});

	const [ webinarData, setWebinarData ] = useState(null);

	const [ errorObj, setErrorObj ] = useState({});

	const navigate = useHistory();

	useEffect(() =>
	{
		setLoading(true);
		getWebinarDetals(meetingId).then((res) =>
		{
			const registeredId = sessionStorage.getItem('registrationId');

			setWebinarData(res.data[0]);

			res.data[0]?.registrationFields?.forEach((each) =>
			{
				setUserDetails((prevState) => ({
					...prevState,
					[each?.field] : ''
				}));
			});

			if (res?.data[0]?.registersData !== undefined && registeredId !== undefined)
			{
				const filteredData = res?.data[0]?.registersData.filter((each) => (each._id) === registeredId);

				if (filteredData.length > 0)
				{
					setRegistrationStatus(true);
					sessionStorage.setItem('approvalStatus', filteredData[0].status);
				}

			}

			setRegistrationType(res.data[0].withRegistration);
			setLoading(false);

		})
			.catch((error) =>
			{
				setLoading(false);
				console.log('error in fetching details', error);
			});
	}, []);

	const handleChange = (e, inputType) =>
	{
		errorObj[e.target.id+'_err'] && setErrorObj((prevState) => ({
			...prevState,
			[e.target.id+'_err'] : ''
		}));

		const trim = e?.target?.value.trim();

		let value;

		if (inputType === 'numeric' && e.target.value !== '')
		{
			value = trim.replace(/e/g, '').slice(0, 50);
		}
		else
		{
			value = trim.slice(0, 50);
		}

		setUserDetails({
			...userDetails,
			[e.target.id] : e.target.id === 'Email' ? value.toLowerCase() : value
		});
		setRegisErr('');
	};

	const validateEmailDomain = (email) =>
	{
		// Extract domain from email
		const domain = email.split('@')[1];

		// Check authorized domains
		if (webinarData?.authorizedDomains?.length > 0)
		{
			const isAuthorizedDomain = webinarData.authorizedDomains.some(
				(authDomain) => domain === authDomain
			);

			if (!isAuthorizedDomain)
			{
				return 'This email domain is not authorized.';
			}
		}

		// Check restricted domains
		if (webinarData?.restrictedDomains?.length > 0)
		{
			const isRestrictedDomain = webinarData.restrictedDomains.some(
				(restrictedDomain) => domain === restrictedDomain
			);

			if (isRestrictedDomain)
			{
				return 'This email domain is not allowed.';
			}
		}
	};

	const handleJoinORContiue = async () =>
	{
		const errObj = {};

		webinarData?.registrationFields?.forEach((each) =>
		{

			if (each?.required && userDetails[each?.field] === '')
			{
				errObj[each?.field + '_err'] = 'Please enter valid ' + each?.field;
			}
			else if (each?.field === 'Email' && each?.required && userDetails['Email'] !== '')
			{
				if (!validateEmail(userDetails['Email']))
				{
					errObj[each?.field + '_err'] = 'Please enter valid ' + each?.field;
				}
				else
				{
					const emailValidation = validateEmailDomain(userDetails['Email']);

					if (emailValidation)
					{
						errObj[each?.field + '_err'] = emailValidation;
					}
				}
			}
			else if (each?.required && ((each?.inputType === 'alpha' && !validateCharacters(userDetails[each?.field])) || (each?.inputType === 'numeric' && !validateIntegers(userDetails[each?.field])) || (each?.inputType === 'alphaNumeric' && !validateAlphaNumericSpecial(userDetails[each?.field]))))
			{
				errObj[each?.field + '_err'] = 'Please enter valid ' + each?.field;
			}
			else
			{
				delete errObj[each?.field + '_err'];
			}
		});
		if (Object.keys(errObj).length === 0)
		{

			setLoading(true);

			const uid = window.btoa(userDetails.Email);

			if (localStorage.getItem('meetingId') === meetingId)
			{
				localStorage.removeItem('meetingId');
				localStorage.removeItem('sessionId');
				localStorage.removeItem('broadcastUserId');
				localStorage.removeItem('broadcastEmailId');
				localStorage.removeItem('broadcastUserName');
			}
			if (localStorage.getItem('meetingId') === null)
			{
				localStorage.setItem('meetingId', meetingId);
				localStorage.setItem('sessionId', sessionId);
				localStorage.setItem('broadcastUserId', uid);
				localStorage.setItem('broadcastEmailId', userDetails.Email);
				sessionStorage.setItem('uid', userDetails.Email);
				localStorage.setItem('uid', userDetails.Email);
				localStorage.setItem('broadcastUserName', userDetails['Full Name']);
			}

			const broadcastBody = {
				name      : userDetails['Full Name'],
				email     : userDetails.Email,
				meetingId : sessionId
			};

			createBroadcastUser(broadcastBody)
				.then((res) =>
				{
					console.log('res', res);
				})
				.catch((err) =>
				{
					console.log('err', err);
				});

			if (registrationType && window.atob(withRegistration) === 'true')
			{
				const { 'Full Name': fullName, 'Email': email, ...remainingData } = userDetails;
				const body = {
					meetingId        : meetingId,
					sessionId        : sessionId,
					firstName        : userDetails['Full Name'],
					email            : userDetails.Email,
					domain           : window.location.hostname,
					userDetails      : remainingData,
					withRegistration : true
				};

				createRegister(body).then((res) =>
				{
					setLoading(false);
					setRegistrationStatus(res.status);
					if (!res.status)
					{
						setRegisErr(res.response);
					}
					if (res.insertedData)
					{
						sessionStorage.setItem('registrationId', res.insertedData._id);
						sessionStorage.setItem('approvalStatus', res.insertedData.status);
						sessionStorage.setItem('webinarMeetingId', meetingId);
					}
				})
					.catch((error) =>
					{
						setLoading(false);
						console.log('error in register', error);
					});
			}
			else
			{
				const { 'Full Name': fullName, 'Email': email, ...remainingData } = userDetails;
				const body = {
					meetingId        : meetingId,
					sessionId        : sessionId,
					firstName        : userDetails['Full Name'],
					email            : userDetails.Email,
					domain           : window.location.hostname,
					userDetails      : remainingData,
					withRegistration : false
				};

				await createRegister(body).then((res) =>
				{
					setLoading(false);
					// if (!res.status)
					// {
					// 	setRegisErr(res.response);
					// }
					// else if (res.status)
					// {
					sessionStorage.setItem('registrationId', res?.data?._id);
					sessionStorage.setItem('approvalStatus', res?.status);
					sessionStorage.setItem('webinarMeetingId', meetingId);
					const displayName = userDetails['Full Name'];

					navigate.push(`/welcome?id=${meetingId}&sessionId=${sessionId}&uid=${uid}&name=${displayName}`);
					setLoading(false);
					// }
				})
					.catch((error) =>
					{
						setLoading(false);
						console.log('error in register', error);
					});

				// const displayName = userDetails['Full Name'];

				// navigate.push(`/welcome?id=${meetingId}&sessionId=${sessionId}&uid=${uid}&name=${displayName}`);
				// setLoading(false);
			}

		}
		else
		{
			setLoading(false);
			setErrorObj(errObj);
		}
	};

	return (

		<div className='flexCol fullH'>
			{/* <div className={`resColRow ${(webinarData?.meetingDescription !== '' || webinarData?.speakersData?.length > 0) ? 'regMain' : 'fullH'}`}> */}
			{!loading && (webinarData && Object.keys(webinarData).length > 0 ? <div className='flexRow resColRow fullH'>
				<div className='flexAutoCol fullH regL overY '>
					<div className='flexRow resColRow aCntr jBtwn hdCntnr'>
						<div className='flexMinWidthCol wTxtCntnr pdngXS'>
							<p className='ellipse lHdng'>{webinarData?.meetingName}</p>
						</div>
						<div className='flexAutoRow resColRow aCntr jBtwn'>
							{webinarData?.startTimeUTC &&
								<div className='flexMinWidthRow pdngXS  aChtr'>
									<img src='/icons/calender.svg' alt='calender' />
									<small className='pdngHSM small'>{new Date(webinarData?.startTimeUTC).toLocaleString('en-US', {
										weekday : 'long',
										month   : 'long',
										day     : 'numeric',
										year    : 'numeric'
									})}{' '}</small>
								</div>
							}
							<div className='flexMinWidthCol pdngXS aEnd jCntr'>
								<WebinarTimer startTime={webinarData?.startTimeUTC} />
							</div>
						</div>
					</div>
					<div className='flexCol'>
						{webinarData?.bannerImage?.length > 0 ? <img src={webinarData?.bannerImage?.find((each) => each?.checked)?.url} alt='eventImg' className='eventI' /> : <img src='https://invc2023uploads.s3.ap-south-1.amazonaws.com/public/bannerImages/1699872695284default_banner.png' alt='eventImg' className='eventI' />}
					</div>
					{(webinarData?.meetingDescription !== '' || webinarData?.speakersData?.length > 0) &&
					<div className='desWeb'>
						<Description webinarData={webinarData} />
					</div>
					}
				</div>
				<div className='flexAutoCol fullH regR'>
					{regisErr && <span className='pdngXXS nameErr'>{regisErr}</span>}
					<div className='flexCol w80 pdngMD'>
						{registrationType ?
							<WithRegistration handleChange={handleChange} hanleContinue={handleJoinORContiue} userDetails={userDetails} errorObj={errorObj} webinarData={webinarData} registrationStatus={registrationStatus} />
							:
							<WithOutRegistration handleChange={handleChange} hanleContinue={handleJoinORContiue} userDetails={userDetails} errorObj={errorObj} registrationStatus={registrationStatus} webinarData={webinarData} />}
					</div>
				</div>
				{(webinarData?.meetingDescription !== '' || webinarData?.speakersData?.length > 0) &&
				<div className='desMob'>
					<Description webinarData={webinarData} />
				</div>
				}
			</div>
				:<LinkExpirePage/>)
			}
			{
				loading && <Loading />
			}
		</div>
	);
}